import axios from "axios";
import Api from "../../customlib/Api";
import Global from "../../customlib/Global";

// Live Chat (DEV-1049) — reuse sesi login Lotus (be_express_token) yang sudah dipakai
// endpoint BE-Express lain di app ini. TIDAK mengubah proses login.
//
// DEV-1193 (revisi) — be_express_token dibuat lavenger tanpa info App Profile, jadi App Profile
// yang dipilih saat login dikirim lewat header ini. Backend memverifikasi sendiri (harus App
// Profile "Live Chat Mitra" dan user ada di userIds-nya), lihat livechatRole.util.ts di lotus-be-express.
export const withAppProfileHeader = (config) => {
    const appProfileId = Global.getAppProfile()?._id;
    if (!appProfileId) return config;
    return { ...config, headers: { ...config.headers, "x-app-profile-id": appProfileId } };
};

const headers = () => withAppProfileHeader(Api.getRequestHeaderJsonNew());

const livechatApi = {
    listBrands: () => axios.get(Api.livechatBrands(), headers()),

    listInbox: (params) => axios.get(Api.livechatInbox(), { ...headers(), params }),

    // DEV-1213/1214 — dashboard performa sales, khusus role tele-leader (dicek di backend).
    getDashboardPerformance: (params) => axios.get(Api.livechatDashboardPerformance(), { ...headers(), params }),

    getSessionDetail: (sessionId, params) =>
        axios.get(Api.livechatSessionDetail(sessionId), { ...headers(), params }),

    sendMessage: (sessionId, body) => axios.post(Api.livechatSendMessage(sessionId), body, headers()),

    // Lampiran dua arah — gambar/video/dokumen (PDF), lihat livechat.agent.controller.ts#uploadFile.
    uploadFile: (file) => {
        const form = new FormData();
        form.append("file", file);
        return axios.post(Api.livechatUploadPhoto(), form, withAppProfileHeader(Api.getRequestHeaderMultipartNew()));
    },

    markRead: (sessionId) => axios.post(Api.livechatMarkRead(sessionId), {}, headers()),

    closeSession: (sessionId) => axios.post(Api.livechatCloseSession(sessionId), {}, headers()),

    setLabel: (sessionId, body) => axios.put(Api.livechatSetLabel(sessionId), body, headers()),

    generateLink: (sessionId) => axios.post(Api.livechatGenerateLink(sessionId), {}, headers()),

    // Pengaturan brand (CRUD) — lihat swagger lotus-be-express, tag "Live Chat - Agent",
    // path /livechat/agent/brand-settings.
    listBrandSettings: () => axios.get(Api.livechatBrandSettings(), headers()),

    getBrandSettings: (brand) => axios.get(Api.livechatBrandSettingsOne(brand), headers()),

    createBrandSettings: (body) => axios.post(Api.livechatBrandSettings(), body, headers()),

    updateBrandSettings: (brand, body) => axios.put(Api.livechatBrandSettingsOne(brand), body, headers()),

    deleteBrandSettings: (brand) => axios.delete(Api.livechatBrandSettingsOne(brand), headers()),

    // Daftar App Profile Lotus (untuk dropdown appProfileId di form Pengaturan Brand) — endpoint
    // existing lintas-modul (bukan bagian livechat), tanpa authMiddleware di backend, lihat
    // src/components/AppProfile/index.jsx untuk pola pemakaian yang sama.
    listAppProfiles: () => axios.post(Api.listAppProfile(), {}, Api.getRequestHeaderNoAuthNew()),

    // DEV-1194 — staff purchasing mulai chat duluan ke mitra (dari menu Daftar Kontak, DEV-1197).
    startSessionToMitra: (body) => axios.post(Api.livechatStartSessionToMitra(), body, headers()),

    // DEV-1198 — panel info order/status pembayaran/ringkasan revisi.
    getOrderInfo: (sessionId) => axios.get(Api.livechatOrderInfo(sessionId), headers()),

    // DEV-1197 — cari mitra by nama/nomor HP untuk menu Daftar Kontak. `searchField` dibatasi ke
    // "name"/"phone" di backend (lihat livechat.mitra-contacts.service.ts). `page` 1-based.
    searchMitraContacts: ({ keyword, searchField = "name", page = 1, limit = 10 } = {}) =>
        axios.get(Api.livechatMitraContacts(), { ...headers(), params: { keyword, searchField, page, limit } }),

    // DEV-1227 — panel konteks customer cuma punya nomor HP (bukan customer_id numerik), backend
    // resolve sendiri lewat `phone` (lihat resolveCustomerIdFromBody di lotus-be-express).
    getCustomerFlag: (phone) => axios.post(Api.customerFlagGet(), { phone }, headers()),

    // DEV-1222 AC1/AC2 — hanya Leader/Supervisor yang lolos (digating backend); Sales biasa dapat 403.
    setCustomerFlag: (phone, changes) => axios.post(Api.customerFlagSet(), { phone, ...changes }, headers()),

    // DEV-1222 AC8 — riwayat perubahan tanda (field/nilai lama-baru/siapa/kapan).
    getCustomerFlagHistory: (phone) => axios.post(Api.customerFlagHistory(), { phone }, headers()),

    getCustomerInsight: (phone) => axios.post(Api.customerInsightGet(), { phone }, headers()),
};

export default livechatApi;
